import React from 'react';
// import Elevator from "../projects/_extra/components/Elevator";
// import Invoice from "./_extra/components/invoice";

const appData = [
	{
		type: '.url',
		title: 'project-vogel',
		name: 'Vögel - Web Book',
		headline: 'Web Book - Application',
		description: "Creative application based on the kinderbücher series \'Vögel\' in Germany",
		launch: 'https://lone-do.github.io/project-vogel',
		github: 'https://github.com/Lone-DO/project-vogel',
		modules: ['SASS', 'HTML5', 'CSS3', 'JavaScript', 'Vue3'],
	},
	{
		type: '.url',
		title: 'project-todo',
		name: 'Angular - Todo WebApp',
		headline: 'Fundamentals Project: Todo Web Application (Angular@20.0)',
		description: '',
		launch: 'https://lone-do.github.io/todo-angular',
		github: 'https://github.com/Lone-DO/todo-angular',
		modules: ['SASS', 'HTML5', 'CSS3', 'JavaScript', 'Angular@20.0'],
	},
	{
		type: '.url',
		title: 'project-zzz',
		name: 'Zenless Zone Zero - Video Store',
		headline: 'Fundamentals Project: Video Game UI (Vue3)',
		description: '',
		launch: 'https://lone-do.github.io/project-zzz',
		github: 'https://github.com/Lone-DO/project-zzz',
		modules: ['SASS', 'HTML5', 'CSS3', 'JavaScript', 'Vue3'],
	},
	{
		type: '.url',
		title: 'project-ac',
		name: 'Animal Crossing Tunes',
		headline: 'Code You: Frontend Course Project',
		description:
			"Creative application that brings the daily soundtracks of Animal Crossing back. Able to choose smoothly between the user's desired Generation, from the hit classics like original Animal Crossing from GameCube, to City Folk from the WII U, and the latest New Leaf on the 3DS. Built with the MERN stack, the backend API utilizes MongoDB as its database.",
		launch: 'https://lone-do.github.io/project-ac',
		github: 'https://github.com/Lone-DO/project-ac',
		modules: [
			'MERN Stack',
			'Mongo',
			'Express',
			'Ember.js',
			'Node.js',
			'SASS',
			'jQuery',
			'HTML5',
			'CSS3',
			'JavaScript',
			'React.js',
		],
	},
	// {
	// 	type: '.url',
	// 	title: 'EmailyApp',
	// 	name: 'Emaily',
	// 	headline: 'Course Project, Built while learning Node & React',
	// 	description: '',
	// 	launch: 'https://lonedo-emaily.herokuapp.com/',
	// 	github: 'https://github.com/Lone-DO/Emaily',
	// 	modules: [
	// 		'Heroku',
	// 		'HTML5',
	// 		'CSS3',
	// 		'JavaScript - ES6',
	// 		'MongdoDB',
	// 		'Express',
	// 		'React',
	// 		'Redux',
	// 		'Node.js',
	// 		'Materialize.css',
	// 		'Sendgrid',
	// 		'Stripe',
	// 		'OAuth',
	// 	],
	// },
	{
		type: '.url',
		title: 'AirlineApp',
		name: 'Airline',
		headline: 'Course Project, Built while learning ES6',
		description: '',
		launch: 'https://lone-do.github.io/travel-site',
		github: 'https://github.com/Lone-DO/travel-site',
		certificate: 'https://www.udemy.com/certificate/UC-MRA7ABA8/',
		modules: ['HTML5', 'CSS3', 'JavaScript', 'Gulp', 'PostCSS', 'jQUery', 'Normalize.CSS'],
	},

	{
		type: '.url',
		title: 'CSharp',
		name: 'C# Shorts',
		headline: 'Projects built while studying C# via Treehouse',
		description: 'My small projects using Node + C#.',
		launch: 'disabled',
		github: 'https://github.com/Lone-DO/Treehouse/tree/master/C%23',
		modules: ['Node.js', 'C#', '.Net'],
	},
	// {
	// 	type: '.url',
	// 	title: 'UndertaleApp',
	// 	name: 'Undertale',
	// 	headline: 'First project, built using Ember.js',
	// 	description:
	// 		"Recreational Project that restructures the original site into a more updated formality. Built using Ember, my first Project I've built as a Developer. Complete overhaul of hands-on coding and features that utilize API information for the user's discretion. Allows fans to post 'Mail' on the site for the Undertale Devs to see, and others to respond to. Built with Ember.js, Backend localStorage.",
	// 	launch: 'https://lone-do.github.io/#/undertale/',
	// 	github: 'https://github.com/Lone-DO/Undertale-Recreation',
	// 	modules: ['HTML5', 'CSS3', 'JavaScript - ES6', 'Ember.js', 'localStorage', 'SASS', 'jQuery'],
	// },
	// {
	//    id: 6,
	//    type: "app",
	//    title: "ElevatorApp",
	//    name: "Elevator",
	//    headline: "JavaScript Short: Elevator Simulator 2019",
	//    description:
	//       "JavaScript Short: Created an app that simulates an elevator, testing state management skills",
	//    launch: [<Elevator />],
	//    github:
	//       "https://github.com/Lone-DO/javascript-widgets/blob/master/src/components/Elevator.js",
	//    modules: ["JavaScript", "React.js"],
	// },
	// {
	//    id: 7,
	//    type: "app",
	//    title: "InvoiceApp",
	//    name: "Invoice Generator",
	//    headline: "JavaScript Short: Data Manipulation",
	//    description:
	//       "JavaScript Short: Sorting generated invoices, testing data manipulation skills.",
	//    launch: [<Invoice />],
	//    github:
	//       "https://github.com/Lone-DO/javascript-widgets/blob/master/src/components/Invoice.js",
	//    modules: ["JavaScript", "React.js"],
	// },
	{
		type: '.url',
		title: 'FCC_Tribute',
		name: 'FCC: Tribute Page',
		headline: 'Free Code Camp Project: Tribute Page',
		description: 'Built a tribute page, hosted via CodePen',
		launch: 'https://codepen.io/lone-do/full/LemKLM',
		github: 'https://codepen.io/lone-do/pen/LemKLM',
		modules: ['HTML, CSS, JavaScript'],
	},
	{
		type: '.url',
		title: 'FCC_Tribute',
		name: 'FCC: Form Page',
		headline: 'Free Code Camp Project: Form Page',
		description: 'Built a form that simulates user input, hosted via CodePen',
		launch: 'https://codepen.io/lone-do/full/MWaeZVB',
		github: 'https://codepen.io/lone-do/pen/MWaeZVB',
		modules: ['HTML, CSS, JavaScript'],
	},
	{
		type: '.url',
		title: 'Scratch',
		name: 'Scratch Game: Pong',
		headline: 'Harvard CS Introduction: Scratch Assignment',
		description: 'Built Pong using Scratch, short and sweet.',
		launch: 'https://scratch.mit.edu/projects/387488765/',
		github: 'https://scratch.mit.edu/projects/387488765/editor',
		modules: ['Scratch'],
	},
	{
		type: '.url',
		title: 'Python',
		name: 'Reddit Client Console',
		headline: 'Code Louisville: Python Course Project',
		description:
			'A console application that is built on the Reddit API, allows you to surf the trending page straight into your console.',
		launch: 'disabled',
		github: 'https://github.com/Lone-DO/Python',
		modules: ['Python', 'Reddit API', 'OOP'],
	},
	{
		type: '.url',
		title: 'C#',
		name: 'Reddit Client UI: r/PhotoshopBattles',
		headline: 'Code You: .Net Course Project',
		description: 'Blazor interface for viewing photoshop submissions in a streamlined view',
		launch: 'disabled',
		github: 'https://github.com/Lone-DO/csharp',
		modules: ['.Net', 'Blazor', ' Reddit API'],
	},
];

export default appData;
